import { closeAll as closeHeader } from "../header-menu-top/header-menu-top.js";

const headerMenuBottomBtn = document.querySelectorAll('.header-menu-bottom__btn')
const headerMenuBottomMenuDesktop = document.querySelectorAll('.header-menu-bottom__menu-desktop')
const headerMenuBottomArrow = document.querySelectorAll('.header-menu-bottom__arrow')

export const closeAll = () => {
  headerMenuBottomArrow.forEach((el) => {
    el.classList.remove('header-menu-bottom__arrow--animation')
  })

  headerMenuBottomMenuDesktop.forEach((el) => {
    el.classList.remove('header-menu-bottom__menu-desktop--open')
  })

  headerMenuBottomBtn.forEach((el) => {
    el.classList.remove('header-menu-bottom__btn--active')
  })
}

for (let i = 0; i < headerMenuBottomBtn.length; i++) {
  headerMenuBottomBtn[i].addEventListener('click', () => {
    if (!headerMenuBottomBtn[i].classList.contains('header-menu-bottom__btn--active')) {
      closeAll()
      closeHeader()
    }

    headerMenuBottomMenuDesktop[i].classList.toggle('header-menu-bottom__menu-desktop--open')
    headerMenuBottomArrow[i].classList.toggle('header-menu-bottom__arrow--animation')
    headerMenuBottomBtn[i].classList.toggle('header-menu-bottom__btn--active')
  })
}
